import { formatNumber } from '@omnipresentgroup/design-system';
import { appendSymbol } from '@omnipresentgroup/helpers';
import {
  type Benefit,
  isBenefitPensionPercentage,
} from '@omnipresentgroup/types';

export const EmployerCost = ({ benefit }: { benefit: Benefit }) => {
  if (benefit.employerCost) {
    return formatNumber({
      input: Number(benefit.employerCost.amount) || 0,
      currency: benefit.employerCost.currency,
    });
  }

  if (benefit.pensionDetails) {
    if (isBenefitPensionPercentage(benefit.pensionDetails)) {
      return appendSymbol(benefit.pensionDetails.employerPercentage, '%', '-');
    }

    return formatNumber({
      input: Number(benefit.pensionDetails.employeeAmount.amount) || 0,
      currency: benefit.pensionDetails.employeeAmount.currency,
    });
  }

  return '-';
};
